import React from 'react';
import Icon from '../Icon';
import Text from '../Text';

type Props = {
  icon?: string;
  iconColor?: string;
  text: string;
  bgOpacity?: number;
  bgColor?: string;
  className?: string;
};

const StatusBadge = ({
  icon,
  iconColor = 'white',
  text,
  bgOpacity = 60,
  bgColor,
  className = '',
}: Props) => {
  const backgroundStyle = bgColor
    ? { background: bgColor }
    : bgOpacity
      ? { backgroundColor: `rgba(0, 0, 0, ${bgOpacity / 100})` }
      : { backgroundColor: 'rgba(0, 0, 0, 1)' };

  return (
    <div
      className={`flex items-center justify-center gap-0.5 px-1.5 py-0.5 rounded-full w-auto h-6 ${className}`}
      style={backgroundStyle}
    >
      {icon && <Icon icon={icon} color={iconColor} width={10} height={10} />}
      <Text
        fontSize={9}
        className="text-white font-semibold whitespace-nowrap leading-tight"
      >
        {text}
      </Text>
    </div>
  );
};

export default StatusBadge;
